<script setup lang="ts">
import type { Schemas } from "#shopware";

const props = withDefaults(
  defineProps<{
    cartItem?: Schemas["LineItem"];
    inputClass?: string;
    decrementButtonClass?: string;
    incrementButtonClass?: string;
  }>(),
  {
    cartItem: undefined,
    inputClass: "",
    decrementButtonClass: "",
    incrementButtonClass: "",
  }
);

const { cartItem } = toRefs(props);
const isLoading = ref(false);

const { trackUpdateCartItemQuantity } = useGtmEvents()
const { itemQuantity, changeItemQuantity } = useCartItem(cartItem);

async function handleItemQuantityUpdate(newQuantity: number) {
  if (!itemQuantity.value || itemQuantity.value === newQuantity) {
    return;
  } else {
    isLoading.value = true;
    await changeItemQuantity(newQuantity);

    trackUpdateCartItemQuantity(cartItem, cartItem.value?.quantity)
    isLoading.value = false;
  }
}
</script>

<template>
  <InputNumber
    :model-value="itemQuantity"
    :step="1"
    :min="1"
    :input-class="[inputClass, 'text-center']"
    :decrement-button-class="decrementButtonClass"
    :increment-button-class="incrementButtonClass"
    showButtons
    buttonLayout="horizontal"
    mode="decimal"
    @update:model-value="handleItemQuantityUpdate"
  >
    <template #decrementicon>
      <span class="pi pi-minus"></span>
    </template>
    <template #incrementicon>
      <span class="pi pi-plus"></span>
    </template>
  </InputNumber>
</template>
